import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()(() => ({
    container: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
}));
